import { useEffect } from 'react';

export const SITE_NAME = 'PSI · Problem Solving Intelligence';
export const SITE_URL = 'https://psintel.com';
const DEFAULT_DESCRIPTION =
  "PSI helps organizations identify not just what failed, but why it failed, and how to build the intelligence to prevent it. Six Sigma, Lean, and structured problem-solving training and consulting.";

// Sets document.title, the meta description, and the canonical link for
// the current route. Runs client-side (this is a plain SPA, no
// server-rendering), but modern search-engine crawlers execute JS and pick
// these up, and it's what makes browser tabs/bookmarks/shares readable.
// Call once per page component, near the top of the render.
//
// Pass `noindex: true` for pages that shouldn't be indexed (e.g. a "record
// not found" result) — see DynamicRecordPage.jsx for an example.
export function usePageMeta(title, description = DEFAULT_DESCRIPTION, { noindex = false } = {}) {
  useEffect(() => {
    document.title = title ? `${title} | ${SITE_NAME}` : SITE_NAME;

    setMetaTag('name', 'description', description);
    setMetaTag('property', 'og:title', title ? `${title} | ${SITE_NAME}` : SITE_NAME);
    setMetaTag('property', 'og:description', description);
    setMetaTag('property', 'og:url', `${SITE_URL}${window.location.pathname}`);
    setMetaTag('name', 'twitter:title', title ? `${title} | ${SITE_NAME}` : SITE_NAME);
    setMetaTag('name', 'twitter:description', description);
    setMetaTag('name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow');

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${SITE_URL}${window.location.pathname}`);
  }, [title, description, noindex]);
}

function setMetaTag(attr, key, content) {
  let tag = document.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}
